import { render, staticRenderFns } from "./questionPaperEntryForm.vue?vue&type=template&id=3b5434f9&scoped=true&"
import script from "./questionPaperEntryForm.vue?vue&type=script&lang=js&"
export * from "./questionPaperEntryForm.vue?vue&type=script&lang=js&"
import style0 from "./questionPaperEntryForm.vue?vue&type=style&index=0&id=3b5434f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5434f9",
  null
  
)

export default component.exports